

































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Mixins } from 'vue-mixin-decorator';

import ErrorMixin from '@/modules/shared/mixins/error.mixin.ts';

import textDecorate from '@/modules/shared/directives/text-decorate.directive.ts';

import Avatar from '@/modules/shared/components/avatar.component.vue';
import Button, {
    ButtonSize,
} from '@/modules/shared/components/button.component.vue';
import Input, {
    InputType,
} from '@/modules/shared/components/input.component.vue';

import { User } from '@/modules/user/model/user.model.ts';
import { Company } from '@/modules/user/model/company.model.ts';
import { Profile } from '@/modules/user/model/profile.model.ts';

import SpotlightText from '@/modules/shared/components/spotlight-text.component.vue';

import ValidationService from '@/modules/core/services/validation.service.ts';


@Component({
    components: {
        Avatar,
        Input,
        Button,
        SpotlightText,
    },
    computed: {
    },
    directives: {
        textDecorate,
    },
})
export default class Signup extends Mixins<ErrorMixin> (ErrorMixin)  {
    private buttonSize = ButtonSize;
    private inputType = InputType;
    private user: User = new User();
    private confirmPassword: string = '';
    private defaultPlaceholder = 'Escribe aquí';
    private inProfile: boolean = false;
    private saveSuccess: boolean = false;
    private loading: boolean = false;
    private errorRepeatPassword = '';
    private avatarFile: string = '';
    private literals: any = {
        title: 'Bienvenido a ECOtr PRO',
        subtitle: 'Regístrate para acceder a ECOtr Pro',
        submit: {
            text: 'registrarme',
        },
    };
    public error: any = {
        firstName: '',
        lastName: '',
        email: '',
        companyName: '',
        profilePhone: '',
        password: '',
        confirmPassword: '',
    };


    get equalPasswords() {
        return (
            this.user.password &&
            this.user.password !== '' &&
            this.confirmPassword &&
            this.confirmPassword !== '' &&
            this.confirmPassword === this.user.password
        );
    }

    get formComplete() {
        let val = false;
        if (this.user.email &&
            this.user.email.length > 0 &&
            this.user.firstName &&
            this.user.firstName.length > 0 &&
            this.user.lastName &&
            this.user.lastName.length > 0 &&
            this.user.profile &&
            this.user.profile.phone &&
            this.user.profile.phone.length > 0 &&
            this.user.company &&
            this.user.company.town &&
            this.user.company.town.length > 0
            ) {
            val = true;
        }
        return val;
    }


    private checkEmailError() {
        let error = false;
        const email = (this.user as any).email || '';
        if (! ValidationService.checkValidEmail(email) ) {
            this.error.email = 'El email introducido no es correcto';
            this.loading = false;
            error = true;
        } else if ( ! ValidationService.checkValidProfesionalEmail(email)  ) {
            this.error.email = 'El email introducido no es un correo profesional';
            this.loading = false;
            error = true;
        }
        return error;
    }

    private send() {
        if ( !this.loading ) {
            this.loading = true;
            this.sendRegister();
        }
    }

    private authRequest( callback = () => { const doNothing = 1; } ) {
            this.$store.dispatch('authRequest', { email: this.user.email, password: this.user.password})
            .then(() => {
                this.getProfile(
                    () => {
                        callback();
                    },
                );
             })
            .catch((err) => { alert('No se pudo loguear'); });
    }

    private sendRegister() {
        if (!this.checkEmailError()) {
            if (this.equalPasswords) {
                this.user.email = (this.user.email as string).toLowerCase();
                this.$store.dispatch('userRegister', { user: this.user } )
                .then(() => {
                    this.authRequest(
                        () => {
                            this.$router.push({ name: 'login', query: { registered: 'true' } });
                            this.loading = false;
                        },
                    );
                })
                .catch( this.onFail );
            } else {
                this.loading = false;
                this.error.confirmPassword = 'Las contraseñas no coinciden';
            }
        }
    }

    private onFail(err: any) {
        this.setFormError(err);
        this.loading = false;
    }

    private phoneFocus() {
        Vue.set(this.user, 'profile', { phone: '(+34)' });
    }

    private getProfile(callback = () => { const doNothing = 1; } ) {
        this.$store.dispatch('fetchProfile')
            .then((profile: User) => {
                this.user = profile;
                callback();
            })
            .catch( this.onFail );
    }

    private setFormError(err: any) {
        const serverError = err.response.data;

        if (serverError.email) {
            this.error.email = serverError.email[0];
        }
        if (serverError.firstName) {
            this.error.firstName = serverError.firstName[0];
        }
        if (serverError.lastName) {
            this.error.lastName = serverError.lastName[0];
        }
        if (serverError.password) {
            this.error.password = serverError.password[0];
        }
        if (serverError.profile) {
            if (serverError.profile instanceof Object) {
                if (serverError.profile.phone) {
                    this.error.profilePhone = serverError.profile.phone[0];
                }
            }
        }
        if (serverError.company) {
            if (serverError.company instanceof Object) {
                if (serverError.company.town) {
                    this.error.companyTown = serverError.company.town[0];
                }
            }
        }
    }


}
